import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "layout-popup-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.24979 12.9344C2.24979 11.4156 3.48101 10.1844 4.99979 10.1844H18.9998C20.5186 10.1844 21.7498 11.4156 21.7498 12.9344V21.0026C21.7498 21.4168 21.414 21.7526 20.9998 21.7526C20.5856 21.7526 20.2498 21.4168 20.2498 21.0026V12.9344C20.2498 12.2441 19.6901 11.6844 18.9998 11.6844H4.99979C4.30944 11.6844 3.74979 12.2441 3.74979 12.9344V20.9893C3.74979 21.4035 3.41401 21.7393 2.99979 21.7393C2.58558 21.7393 2.24979 21.4035 2.24979 20.9893V12.9344Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.752 15.9827C17.752 16.3969 17.4162 16.7327 17.002 16.7327H6.99784C6.58363 16.7327 6.24784 16.3969 6.24784 15.9827C6.24784 15.5684 6.58363 15.2327 6.99784 15.2327H17.002C17.4162 15.2327 17.752 15.5684 17.752 15.9827Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.752 19.9843C17.752 20.3985 17.4162 20.7343 17.002 20.7343H6.99784C6.58363 20.7343 6.24784 20.3985 6.24784 19.9843C6.24784 19.5701 6.58363 19.2343 6.99784 19.2343H17.002C17.4162 19.2343 17.752 19.5701 17.752 19.9843Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.24951 4.99731C2.24951 3.47853 3.48073 2.24731 4.99951 2.24731H18.9995C20.5183 2.24731 21.7495 3.47853 21.7495 4.99731V8.27246C21.7495 8.68667 21.4137 9.02246 20.9995 9.02246C20.5853 9.02246 20.2495 8.68667 20.2495 8.27246V4.99731C20.2495 4.30696 19.6899 3.74731 18.9995 3.74731H4.99951C4.30916 3.74731 3.74951 4.30696 3.74951 4.99731V8.29066C3.74951 8.70487 3.41373 9.04066 2.99951 9.04066C2.5853 9.04066 2.24951 8.70487 2.24951 8.29066V4.99731Z"
    }, null, -1)
  ])))
}
export default { render: render }